import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../api/api';
import { useFormik } from 'formik';
import * as yup from "yup";
import { useToken } from '../components/TokenProvider';

export default function Signup() {
    const [message, setMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isOTPSent, setIsOTPSent] = useState(false);
    const navigate = useNavigate();
    const { hash } = useParams();  // Get the link_hash from the URL parameters
    let isURLValid = true;
    const { accessToken, setToken, setLinkHashInLocal } = useToken(); // Access the token from context
    
    useEffect(() => {
        if (hash) {
            localStorage.setItem('link_hash', hash);  // Store link_hash in sessionStorage
            setLinkHashInLocal(hash);  // Set link_hash in context
        }
        if(hash && accessToken){
            navigate('/startPage');
        }
    }, [hash, accessToken,navigate]);

    const emailValidationSchema = yup.object({
        email: yup
            .string("Enter email address")
            .email("Enter a valid email")
            .required("Email address is required"),
    });

    const otpValidationSchema = yup.object({
        otp: yup
            .string("Please enter OTP")
            .required("Please enter OTP"),
    });

    const emailFormik = useFormik({
        initialValues: {
            email: "",
        },
        validationSchema: emailValidationSchema,
        onSubmit: async (values) => {
            const { email } = values;
            try {
                setIsSubmitting(true);
                const response = await api.post('/user/auth/email_otp_login/', { email });
                setMessage(response.data.message);
                setIsSubmitting(false);
                setIsOTPSent(true);
            } catch (error) {
                setIsSubmitting(false);
                setMessage(error.response?.data.message || 'An error occurred. Please try again.');
            }
        }
    });

    const otpFormik = useFormik({
        initialValues: {
            otp: "",
        },
        validationSchema: otpValidationSchema,
        onSubmit: async (values) => {
            const { otp } = values;
            try {
                setIsSubmitting(true);
                const response = await api.put('/user/auth/email_otp_login/', { email: emailFormik.values.email, otp: otp });
                const { access, refresh, message: responseMessage } = response.data;

                // Store the access token in localStorage or session storage for authentication
                setToken(access);
                localStorage.setItem('refreshToken', refresh);
                setIsSubmitting(false);

                setMessage(responseMessage);

                // Redirect the user to a protected route upon successful login
                navigate('/startpage');  // Replace '/protected' with your actual protected route
            } catch (error) {
                setIsSubmitting(false);
                setMessage(error.response?.data.message || 'An error occurred. Please try again.');
            }
        }
    });

    return (
        <div>
            <div className="d-flex justify-content-center align-items-center full-height-background">
                <div className="col-10 p-sm-8 col-md-5 col-lg-5 col-xl-4" style={{ opacity: "0.85" }}>
                    {isURLValid ?
                        <div className="card p-4 p-md-5 p-sm-3 my-4">
                            <form className='login-form'>
                                <h2 className='mb-4 mb-sm-5 text-center fw-bold'>Login</h2>
                                <div className="mb-4">
                                    <label htmlFor="email" className="form-label">Email<span className="text-danger">*</span></label>
                                    <input
                                        type="email"
                                        className="form-control forminput-custom"
                                        id="email"
                                        placeholder="name@example.com"
                                        value={emailFormik?.values?.email}
                                        name='email'
                                        onBlur={emailFormik.handleBlur}
                                        onChange={emailFormik.handleChange}
                                        error={
                                            emailFormik?.touched?.email &&
                                            Boolean(emailFormik?.errors?.email)
                                        }
                                        required
                                    />
                                    {emailFormik?.touched?.email &&
                                        <small id="passwordHelpBlock" class="form-text text-danger">
                                            {emailFormik.errors.email}
                                        </small>}
                                </div>
                                {isOTPSent && <div className="mb-4">
                                    <div className="mt-3 alert alert-info">Please enter the OTP sent to your email</div>
                                    <label htmlFor="otp" className="form-label">OTP</label>
                                    <input
                                        type="text"
                                        className="form-control forminput-custom"
                                        id="otp"
                                        value={otpFormik?.values?.otp}
                                        name='otp'
                                        onBlur={otpFormik.handleBlur}
                                        onChange={otpFormik.handleChange}
                                        error={
                                            otpFormik?.touched?.otp &&
                                            Boolean(otpFormik?.errors?.otp)
                                        }
                                        maxLength={6}
                                        onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '').slice(0, 6); }}
                                        required
                                    />
                                    {otpFormik?.touched?.otp &&
                                        <small id="passwordHelpBlock" class="form-text text-danger">
                                            {otpFormik.errors.otp}
                                        </small>}
                                </div>}
                                <div className="d-grid">
                                    <button type="submit" className="btn btn-success" disabled={isSubmitting} onClick={isOTPSent ? otpFormik?.handleSubmit : emailFormik.handleSubmit}>
                                        {isSubmitting ? <><span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            <span class="sr-only">Submitting...</span></> : "Submit"}
                                    </button>
                                </div>
                            </form>
                            {message && <div className="mt-3 alert alert-info">{message}</div>}
                        </div> :
                        message && <div className="mt-3 alert alert-info">Link </div>
                    }
                </div>
            </div>
        </div>
    );
}


